
import { Bank, Purchase } from "@/models/base";
import { BankType } from "@/models/base";
import { Sale } from "@/models/base";
import { BankKind } from "@/models/base/bank";
import { BankService } from "@/services/bank-service";
import { BookYearService } from "@/services/book-year-service";
import { SupplierService } from "@/services/supplier-service";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { CustomerService } from "../../services/customer-service";
import {DossierConfigService} from "@/services";
import { IBankBookingFavorite } from "@/models/dossier-configs/bank-config";
import AppSelectBankFavorite from "./SelectBankFavorite.vue";
import { isGreaterDate, isSmallerDate } from "@/utils/date-utils";

export default Vue.extend({
	data() {
		return {
			bankTypes: [] as BankType[],
			bank: new Bank(),
			saving: false,
			favorites: DossierConfigService.getBankConfig().Favorites as IBankBookingFavorite[]
		};
	},
	props: {
		sale: Object as () => Sale,
		purchase: Object as () => Purchase,
	},
	computed: {
		bankTypeItems(): ISelectItem<number>[] {
			return this.bankTypes.filter(t => t.ShowInAccounting == true).map(t => {
				return {
					text: t.Name,
					value: t.ID
				};
			});
		},
		locale(): string {
			return this.$i18n.locale;
		},
		bookYearStartDate():Date {
			return BookYearService.getBookYearStartDate(this.bank.BookYear || BookYearService.selectedBookYear);
		},
		bookYearEndDate():Date {
			return BookYearService.getBookYearEndDate(this.bank.BookYear || BookYearService.selectedBookYear);
		},
		isDateValid():boolean{
			if (isGreaterDate(this.bank.TimeCreated, this.bookYearEndDate)){
				return false;
			}
			if (isSmallerDate(this.bank.TimeCreated, this.bookYearStartDate)){
				return false;
			}
			return true;
		},
		isValid():boolean{
			return this.isDateValid;
		}
	},
	methods: {
		async finish() {
			if (!this.isValid) return;
			if (this.saving) return;
			this.saving = true;
			try{
				if (!this.bank.BookYear)
					this.bank.BookYear = BookYearService.selectedBookYear;
				if (this.bank.InvoiceID > 0) {
					this.bank.TotalDC = this.bank.Total;
				}else if(this.bank.PurchaseID > 0){
					this.bank.TotalDC = -this.bank.Total;
				}
				this.bank = await BankService.postBooking(this.bank);
				this.$emit("bank-saved", this.bank);
				this.$emit("update");
				this.$wf.notify(this.$ct("save-success").toString(), "success", 3000, "check");
			}catch(err){
			}finally{
				this.saving = false;
			}
		},
		cancel() {
			this.$emit("cancel");
		},
		applyFavorite(favorite:IBankBookingFavorite){
			this.bank.TypeID = favorite.TypeID;
			if (favorite.Info){
				this.bank.Info = favorite.Info;
			}
		}
	},
	async created() {
		this.bankTypes = await BankService.getTypes();
		if (this.sale) {
			//this.bank.Total = this.sale.TotalOpen;
			console.log(this.sale.TotalOpen);
			this.bank.Total = Number(Math.round(Number(this.sale.TotalOpen + "e2")) + "e-2");
			console.log(this.bank.Total);
			this.bank.Contact = await CustomerService.getContact(this.sale.ContactID);
			this.bank.ContactID = this.sale.ContactID;
			this.bank.FriendlySaleID = this.sale.ComputedFriendlyID;
			this.bank.InvoiceID = this.sale.ID;
			this.bank.BookYear = this.sale.BookYear;
			this.bank.Kind = BankKind.Sale;
			this.bank.TypeID = DossierConfigService.getGeneralConfig().DefaultBankTypeID || BankService.getTypes()[0].ID;
		} else if (this.purchase) {
			this.bank.Total = this.purchase.TotalOpen;
			this.bank.Contact = await SupplierService.getContact(this.purchase.ContactID);
			this.bank.ContactID = this.purchase.ContactID;
			this.bank.FriendlyPurchaseID = this.purchase.ComputedFriendlyID;
			this.bank.PurchaseID = this.purchase.ID;
			this.bank.Kind = BankKind.Purchase;
			this.bank.BookYear = this.purchase.BookYear;
		}
	},
	components: {
		AppSelectBankFavorite
	},
	i18nEx: {
		componentPrefix: "components.bank"
	}
});
